export default __webpack_public_path__ + "static/media/restriction.a2668f7d.webp";